import { defineComponent as _defineComponent } from 'vue'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/vue.es'
import { countDownTime, slidesCountOnTimeCountdown } from './const'
import { useCountDown } from './utils/useCountDown'

export default /*#__PURE__*/_defineComponent({
  __name: 'CountdownTimer',
  setup(__props) {

const animation = { duration: 30000, easing: (t) => t }
const getPositiveNumber = (number: number) => Math.max(0, number)

const slidesArray = Array(slidesCountOnTimeCountdown).fill(0)
const { hours, minutes, seconds } = useCountDown(countDownTime)

const [wrapper] = useKeenSlider({
  loop: true,
  renderMode: 'performance',
  slides: {
    origin: 'center',
    perView: window.innerWidth / 500,
    spacing: 10,
  },
  drag: false,
  created(s) {
    s.moveToIdx(1, true, animation)
  },
  updated(s) {
    s.moveToIdx(s.track.details.abs + 1, true, animation)
  },
  animationEnded(s) {
    s.moveToIdx(s.track.details.abs + 1, true, animation)
  },
})

return { __sfc: true,animation, getPositiveNumber, slidesArray, hours, minutes, seconds, wrapper }
}

})